import React from 'react';
import { MobileMenuItemWrapperProps } from 'features/toolbar/types';
import { useWhiteboardControl } from 'features/toolbar/toolbar/controls/whiteboard/useWhiteboardControl';
import MobileMenuItem from 'features/toolbar/toolbar/mobile/MobileMenuItem';
import { openModal } from 'features/modal/modalSlice';
import { useAppDispatch } from 'store/hooks';

const WhiteboardControlMobile = ({ onClick }: MobileMenuItemWrapperProps) => {
  const dispatch = useAppDispatch();

  const { active, label, isFeatureAvailable } = useWhiteboardControl();

  if (!isFeatureAvailable) {
    return null;
  }

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    dispatch(openModal('whiteboards'));
    onClick?.(event);
  };

  return (
    <MobileMenuItem
      id="whiteboard-control"
      icon="whiteboard"
      onClick={handleClick}
      selected={active}
    >
      {label}
    </MobileMenuItem>
  );
};

export default WhiteboardControlMobile;
